import { Factory, trait } from 'miragejs'
import { faker } from '@faker-js/faker'

export default Factory.extend({
  // make the first collection a favourites collection
  isFavourite(i) {
    return i === 0
  },

  name(i) {
    return this.isFavourite ? 'My Faves' : `Collection Name ${i}`
  },

  // count, coverPreviewImg, coverFullImg are added in automatically by the serializer

  lastUpdated() {
    return faker.date.recent({ days: 30 })
  },

  withBooks: trait({
    afterCreate(collection, server) {
      const numOfBooks = faker.number.int({ min: 1, max: 10 })
      const books = server.createList('book-library/book', numOfBooks)
      collection.books = books
      collection.save()
    },
  }),
})
